<template>
  <div class="phone" @click="handleBodyClick">
    <div v-if="!composeEmailLoading">
      <!-- Primary header -->
      <header-vue v-on:sendEmail="checkMailContact" v-on:goBackToPrevRoute="goBackToPrevRoute"/>

      <transition name="swipe" mode="out-in">

        <!-- Section -->
        <div class="compose-email-container">

          <!-- To Section -->
          <div class="to-section" @click="handleAddressSectionClick('to')">
            <span class="compose-label"> To:</span>

            <!-- The selected mail id chip goes here. -->
            <ul class="selected-to-email">
              <template v-if="selectedTo.length > 0">
                <li v-for="(contact, index) in selectedTo" :key="contact.id">
                  <span>{{ contact.name }}</span>
                  <span class="icon-close" @click="removeToContact(index)"></span>
                </li>
              </template>
              <li>
                <input
                  type="text"
                  ref="toInputTextBox"
                  id="toInputTextBox"
                  v-show="toTxtBoxToggle"
                  v-model="toTxtBoxVal"
                  @focus="focus('to')"
                  @input="toTextBoxInputChange($event.target.value)"
                  v-focus-on-load
                />
                <ul class="email-autosuggestions" id="to-auto-suggest-box" v-show="tofilteredContact.length > 0">
                  <li
                    v-for="contact in tofilteredContact"
                    @click="pushToContact($event, contact)"
                    :key="contact.id"
                  >
                    {{ contact.name }}
                  </li>
                </ul>
              </li>
            </ul>

            <!--The add icon goes here-->
            <span class="add-more" id="toAddIcon" v-show="toAddIconToggle" @click="displayContactList($event, 'to')" ></span>

            <!-- The contact list pop-up section goes here. -->
            <transition name="pop-up">
              <div
                :class="{'contacts-container': true, 'collapsed': isMinimized}"
                v-show="displayContactListPopup"
                @click="stopPropagate($event)"
              >
                <div class="contacts-header">
                  <h5>Choose a contact to mail</h5>
                  <h2>  Contacts <a @click="hideContactList" href="javascript:void(0)">Done</a></h2>
                  <a href="javascript:void(0)" @click="minimizeOrMaximize" :class="{
                    'close-contacts-list' : !isMinimized,
                    'expand-contacts-list': isMinimized
                  }"></a>
                </div>
                <ul class="all-contacts-list" v-if="'to' === contactListDisplay">
                  <li v-for="contact in getContactList" :key="contact.id" @click="toggleToContact(contact)">
                    {{ contact.name }}
                    <span class="contact-selected active" v-if="searchOnContact(contact.id, selectedTo)"></span>
                    <!--<span class="deselect-contact"></span>-->
                  </li>
                </ul>

                <ul class="all-contacts-list" v-if="'cc' === contactListDisplay">
                  <li v-for="contact in getContactList" :key="contact.id" @click="toggleCcContact(contact)">
                    {{ contact.name }}
                    <span class="contact-selected" v-if="searchOnContact(contact.id, selectedCc)"></span>
                    <!--<span class="deselect-contact"></span>-->
                  </li>
                </ul>

                <ul class="all-contacts-list" v-if="'bcc' === contactListDisplay">
                  <li v-for="contact in getContactList" :key="contact.id" @click="toggleBccContact(contact)">
                    {{ contact.name }}
                    <span class="contact-selected" v-if="searchOnContact(contact.id, selectedBcc)"></span>
                    <!--<span class="deselect-contact"></span>-->
                  </li>
                </ul>
              </div>
            </transition>
          </div>

          <!-- CC Section -->
          <div class="cc-section" @click="handleAddressSectionClick('cc')">
            <span class="compose-label">  {{ ccBccText }}:</span>

            <!-- The selected mail id chip goes here. -->
            <ul class="selected-cc-email">
              <template v-if="selectedCc.length > 0">
                <li v-for="(contact, index) in selectedCc" :key="contact.id">
                  <span>{{ contact.name }}</span>
                  <span class="icon-close" @click="removeCcContact(index)"></span>
                </li>
              </template>
              <li>
                <input
                  type="text"
                  ref="ccInputTextBox"
                  v-model="ccTxtBoxVal"
                  v-show="ccTxtBoxToggle"
                  id="ccInputTextBox"
                  @focus="focus('cc')"
                  @input="ccTextBoxInputChange($event.target.value)"
                />
                <ul class="email-autosuggestions" id="cc-auto-suggest-box" v-show="ccfilteredContact.length > 0">
                  <li
                    v-for="contact in ccfilteredContact"
                    @click="pushCcContact($event, contact)"
                    :key="contact.id"
                  >
                    {{ contact.name }}
                  </li>
                </ul>
              </li>
            </ul>

            <!--The add icon goes here-->
            <span class="add-more" id="ccAddIcon" v-if="ccAddIconToggle" @click="displayContactList($event, 'cc')"></span>
          </div>

          <!-- Bcc Section -->
          <div class="bcc-section" v-if="showBcc" @click="handleAddressSectionClick('bcc')">
            <span class="compose-label">  Bcc:</span>

            <!-- The selected mail id chip goes here. -->
            <ul class="selected-bcc-email">
              <template v-if="selectedBcc.length > 0">
                <li v-for="(contact, index) in selectedBcc" :key="contact.id">
                  <span>{{ contact.name }}</span>
                  <span class="icon-close" @click="removeBccContact(index)" ></span>
                </li>
              </template>
              <li>
                <input
                  type="text"
                  ref="bccInputTextBox"
                  id="bccInputTextBox"
                  v-show="bccTxtBoxToggle"
                  v-model="bccTxtBoxVal"
                  @focus="focus('bcc')"
                  @input="bccTextBoxInputChange($event.target.value)"
                />
                <ul class="email-autosuggestions" id="bcc-auto-suggest-box" v-show="bccfilteredContact.length > 0">
                  <li
                    v-for="contact in bccfilteredContact"
                    @click="pushBccContact($event, contact)"
                    :key="contact.id"
                  >
                    {{ contact.name }}
                  </li>
                </ul>
              </li>
            </ul>

            <!--The add icon goes here-->
            <span class="add-more" id="bccAddIcon" v-if="bccAddIconToggle" @click="displayContactList($event, 'bcc')"></span>
          </div>

          <!-- Subject Section -->
          <div class="subject-section" @click="handleSubjectSectionClick">
            <span class="compose-label"> Subject:</span>
            <input type="text" v-model="emailSubject" ref="emailSubject" />
          </div>

          <!-- Signature and file Section -->
          <div class="upperbody-section">

            <div class="include-signature">

              <label class="container-checkbox">
              <span :class="{'checkmark': true, 'checked': includeSignature}"></span>
              <input type="checkbox" v-model="includeSignature" @change="checkAndIncludeSignature">
              </label> Include Signature

              <!-- File Attachment Section -->
              <img
                src="../../../assets/img/paperclip.png"
                alt="Attachment"
                @click="openSelectFileWindow()"
                class="icon-attachment"
              />

              <!-- Upon clicking display list of signature -->
              <span class="select-sig" v-if="includeSignature" @click="selectSignature">Select</span>

              <!-- The actual input file button which is hidden from UI -->
              <span class="hide">
                <input type="file" id="file" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple />
              </span>

            </div>

            <!-- Signature List Section -->
            <ul class="all-signatures"  v-if="includeSignature && showSignatures && (signatures.length > 0)">
              <li v-for="signs in signatures" @click="setSignature(signs, true)" :key="signs.id" class="indv-signature">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="sign-1" :value="signs.id" v-model="emailSignature.id">
                  <label class="form-check-label">
                    <div class="radio-con" v-html="signs.signature">
                    </div>
                  </label>
                </div>
              </li>
            </ul>

            <!-- Attached File List Section -->
            <div class="signature-files">
              <template v-for="(file, index) in files">
                <template v-if="file.showUI">
                  <div class="signature-file-con" :key="file.fileId" v-if="!file.progress">
                      {{
                          file.fileDetail.name.length > 20 ?
                          file.fileDetail.name.substring(0, 20) + '...' + file.fileDetail.name.split('.').pop() :
                          file.fileDetail.name
                      }}
                      <span class="file-close" v-if="!file.hideCloseIcon" @click="removeFile(index)"></span>
                  </div>

                  <!--Progress Bar-->
                  <div class="progress-bar-container" :key="file.fileId" v-else>
                    <div class="progress-bar-area">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="file.uploadPercentage"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{ file.uploadPct }}%
                        </div>
                      </div>
                    </div>
                    <!--<a class="cancel-upload"></a>-->
                    <div class="clear"></div>
                  </div>
                </template>
              </template>
            </div>
          </div>

          <!--The email body section-->
          <div class="lowerbody-section">
            <editor
              v-model="emailBody"
              tinymce-script-src="tinymce/js/tinymce/tinymce.min.js"
              id="mailBody"
              :init="{
                menubar:false,
                statusbar: false,
                toolbar: false,
                placeholder: 'Compose Message',
                content_style : `
                  #forwardMsgDottedLine {
                    white-space: nowrap !important;
                  }
                  .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
                    color: #666;
                    font-size:15px;
                    font-family:sans-serif!important;
                  }
                `
              }"
              @onInit="editorInitialized"
              @onFocus="editorFocused"
            />

            <!--The selected signature section-->
            <div class="signature-preview"
              v-if="includeSignature && (emailSignature.id !== 0) && !showSignatureInsideMailBody"
              v-html="emailSignature.signature">
            </div>
          </div>

          <!-- Mail contact confirm modal -->
          <transition name="zoom">
            <mail-contact-confirm
              :mailContactText="mailContactText"
              :hideConfirmBox="hideConfirmBox"
              :sendEmail="sendEmail"
              v-show="showMailContactConfirmBox"
            ></mail-contact-confirm>
          </transition>

        </div>

      </transition>
    </div>

    <transition name="fade">
      <div class="loader-container" v-if="composeEmailLoading">
        <loader-vue />
      </div>
    </transition>
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { authMixin } from "../../../mixins/authMixin";
import { permissionMixin } from "../../../mixins/permissionMixin";
import { addNewChatAndCallMixin } from "../../../mixins/addNewChatAndCallMixin";
import LoaderVue from "../../Appointment/common/Loader";
import { ERROR_MESSSAGE } from "../../../store/config";
import axios from "axios";
import Vue from "vue";
import Editor from '@tinymce/tinymce-vue';
import MailContactConfirm from './MailContactConfirm';

export default {
  mixins: [authMixin, permissionMixin, addNewChatAndCallMixin],
  data() {
    return {
      // The to input related variables.
      selectedTo:[],
      tofilteredContact:[],
      toAddIconToggle: false,
      toTxtBoxVal: '',
      toTxtBoxToggle: true,

      // The cc input related variables.
      selectedCc:[],
      ccfilteredContact:[],
      ccAddIconToggle: false,
      ccTxtBoxVal: '',
      ccTxtBoxToggle: true,

      // The bcc input related variables.
      selectedBcc:[],
      bccfilteredContact:[],
      bccAddIconToggle: false,
      bccTxtBoxVal: '',
      bccTxtBoxToggle: true,

      showBcc: false,

      // The files related variables.
      files:[],
      fileCount: 0,

      // The signature related stuffs.
      includeSignature: false,
      emailSignature: {
        id:0,
        signature: 'No signature',
        is_default: 1
      },
      showSignatures: false,
      showSignatureInsideMailBody: false,

      // All the icons
      addNewIcon: require("../../../assets/img/m_email-active.png"),

      ccBccText: 'Cc/Bcc',
      displayContactListPopup: false,
      contactListDisplay: '',
      emailBody: '',
      emailSubject: '',
      mailActionType: false,
      mailId: 0,
      emailFormData: null,

      // MailContact alert box related properties
      showMailContactConfirmBox: false,
      mailContactText: '',

      // Setting the initial mail details - In case of reply/forward/reply-all/edit draft
      initialMailDetail: null,

      isMinimized: false,
      clickedAddressSection: ''
    };
  },
  components: {
    HeaderVue,
    LoaderVue,
    'editor': Editor,
    MailContactConfirm
  },
  computed: {
    ...mapGetters("portalemail", {
      getContactList: "getContactList",
      composeEmailLoading: "getComposeEmailLoading",
      getInitialMailDetails: "getInitialMailDetails",
      signatures: "getSignatures",
      selectedUserId: "getSelectedUserId"
    }),
    ...mapGetters({
      previousRoute: "getPreviousRoute"
    })
  },
  methods: {
    ...mapActions("portalemail", {
      fetchAllContacts: "fetchAllContacts",
      removeAttachment: "removeAttachment",
      sendMail: "sendMail"
    }),
    ...mapMutations("portalemail", {
      resetEmails: "resetEmails",
      setBoxCount: "setBoxCount",
      setComposeEmailLoading: "setComposeEmailLoading",
      setInitialMailDetails: "setInitialMailDetails"
    }),

    stopPropagate(event) {
      event.stopPropagation();
    },

    /**
     * Function to hide the mail contact alert confirmation box
     */
    hideConfirmBox() {
      this.showMailContactConfirmBox = false;
    },

    /**
     * Function to remobe mail id from rectangular chip section
     */
    removeEmail(event) {
      event.stopPropagation();
    },

    /**
     * Event handler to hide contact list
     */
    hideContactList() {
      this.isMinimized = false;
      this.displayContactListPopup = false;
      this.focusAddressSection();
    },

    /**
     * Function to minimize/maximize the contact list
     */
    minimizeOrMaximize() {
      this.isMinimized = !this.isMinimized;
      if(this.isMinimized) {
        this.focusAddressSection();
      }
    },

    /**
     * Function to focus on address section
     */
    focusAddressSection() {
      if('to' === this.clickedAddressSection) {
        this.$refs.toInputTextBox.focus();
      } else if('cc' === this.clickedAddressSection) {
        this.$refs.ccInputTextBox.focus();
      } else if('bcc' === this.clickedAddressSection) {
        this.$refs.bccInputTextBox.focus();
      }
    },

    /**
     * Event handler to display contact list
     */
    displayContactList(event, contactListToDisplay) {
      event.stopPropagation();
      this.clickedAddressSection = contactListToDisplay;
      this.tofilteredContact = [];
      this.ccfilteredContact = [];
      this.bccfilteredContact = [];
      this.toTxtBoxVal = '';
      this.$refs.toInputTextBox.blur();
      this.ccTxtBoxVal = '';
      this.$refs.ccInputTextBox.blur();
      this.bccTxtBoxVal = '';
      if(this.showBcc) {
        this.$refs.bccInputTextBox.blur();
      }
      this.displayContactListPopup = true;
      this.isMinimized = false;
      this.contactListDisplay = contactListToDisplay;
    },

    /**
     * The tinymce editor initialize
     */
    editorInitialized(event, editor) {
      /*if(this.initialMailDetail && !this.initialMailDetail.signature) {
        editor.dom.remove('signatureDiv');
      }*/
    },

    /**
     * The tinymce editor focused
     */
    editorFocused(event, editor) {
      this.handleBodyClick();
    },

    /**
     * Function to handle on focus of input
     */
    focus(clickedSection) {
      switch(clickedSection) {
        case "to":
          this.toAddIconToggle = true;
          this.ccAddIconToggle = false;
          this.bccAddIconToggle = false;

          if(this.selectedCc.length > 0) {
            this.ccTxtBoxToggle = false;
          }

          if(this.selectedBcc.length > 0) {
            this.bccTxtBoxToggle = false;
          }

          this.ccTxtBoxVal = '';
          this.bccTxtBoxVal = '';
          break;
        case "cc":
          this.showBcc = true;
          this.ccBccText = 'Cc';
          this.ccAddIconToggle = true;
          this.toAddIconToggle = false;
          this.bccAddIconToggle = false;

          if(this.selectedTo.length > 0) {
            this.toTxtBoxToggle = false;
          }

          if(this.selectedBcc.length > 0) {
            this.bccTxtBoxToggle = false;
          }

          this.toTxtBoxVal = '';
          this.bccTxtBoxVal = '';
          break;
        case "bcc":
          this.bccAddIconToggle = true;
          this.toAddIconToggle = false;
          this.ccAddIconToggle = false;

          if(this.selectedTo.length > 0) {
            this.toTxtBoxToggle = false;
          }

          if(this.selectedCc.length > 0) {
            this.ccTxtBoxToggle = false;
          }

          this.toTxtBoxVal = '';
          this.ccTxtBoxVal = '';
      }
    },

    /**
     * Function to handle on clicking of address section
     */
    handleAddressSectionClick(clickedSection) {
      event.stopPropagation();
      switch(clickedSection) {
        case "to":
          if(this.ccfilteredContact.length > 0) {
            this.ccfilteredContact = [];
          }
          if(this.showBcc && (this.bccfilteredContact.length > 0)) {
            this.bccfilteredContact = [];
          }

          this.toTxtBoxToggle = true;
          if(!this.displayContactListPopup || (this.displayContactListPopup && this.isMinimized)) {
            Vue.nextTick(() => {
              this.$refs.toInputTextBox.focus();
            });
          }
          break;
        case "cc":
          if(this.tofilteredContact.length > 0) {
            this.tofilteredContact = [];
          }
          if(this.showBcc && (this.bccfilteredContact.length > 0)) {
            this.bccfilteredContact = [];
          }

          this.ccTxtBoxToggle = true;
          if(!this.displayContactListPopup || (this.displayContactListPopup && this.isMinimized)) {
            Vue.nextTick(() => {
              this.$refs.ccInputTextBox.focus();
            });
          }
          break;
        case "bcc":
          if(this.tofilteredContact.length > 0) {
            this.tofilteredContact = [];
          }
          if(this.ccfilteredContact.length > 0) {
            this.ccfilteredContact = [];
          }

          this.bccTxtBoxToggle = true;
          if(!this.displayContactListPopup || (this.displayContactListPopup && this.isMinimized)) {
            Vue.nextTick(() => {
              this.$refs.bccInputTextBox.focus();
            });
          }
      }
    },

    /**
     * Event handler on clicking any where of subject section
     */
    handleSubjectSectionClick() {
      this.$refs.emailSubject.focus();
    },

    /**
     * Function to open select file window
     */
    openSelectFileWindow() {
      this.$refs.myFiles.click();
    },

    /**
     * Function to upload file to backend
     */
    previewFiles(event) {
      for (var i = 0; i < this.$refs.myFiles.files.length; i++) {
          const fileSize = Math.round((this.$refs.myFiles.files.item(i).size / 1024));
          if (fileSize > 10240) {
            this.$store.dispatch("globalMessagePopup", "File Size must be less then 10 MB.");
          } else {

            let formData = new FormData();
            formData.append(0, this.$refs.myFiles.files[i]);
            formData.append('selectedSubscriberId', this.$store.getters.getSelectedProviderID);
            formData.append('appUserId', this.selectedUserId);
            let index = this.files.length;
            let file = {
              progress: true,
              uploadPct: 0,
              uploadPercentage: {
                width: '0%'
              },
              showUI: true
            };
            Vue.set(this.files, index, file);
            axios({
              url: "/portalemail/uploadFile",
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
                token: this.$store.getters.userInfo.token,
                userid: this.$store.getters.userInfo.userId
              },
              onUploadProgress: progressEvent => {
                let uploadPercentage = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
                file.uploadPct = uploadPercentage;
                file.uploadPercentage = {
                  width: uploadPercentage + '%'
                };
                Vue.set(this.files, index, file);
              },
              redirect: "follow",
              referrer: "no-referrer",
              data: formData
            }).then(response => {
              let data = response.data;
              if(data.error) {
                file.showUI = false;
                Vue.set(this.files, index, file);
                this.$store.dispatch("globalMessagePopup", data.error);
              } else {
                file.progress = false;
                file.fileId = data.fileId;
                file.fileDetail = {
                  name: data.fileName
                };
                Vue.set(this.files, index, file);
              }
            }).catch(err => {
              const res = err.response;

              // Logout when user is unauthorized
              if (res != undefined) {
                if (res.status === 401) {
                  this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE[401]);
                  if (this.$store.getters.checkSession) {
                    this.$store.dispatch("logout");
                  }
                  return;
                }

                file.showUI = false;
                Vue.set(this.files, index, file);
              }
            });
          }
      }
    },

    /**
     * Function to remove a file from backend
     */
    async removeFile(index) {
      var json = await this.removeAttachment({
        fileId: this.files[index].fileId,
        selectedSubscriberId: this.$store.getters.getSelectedProviderID
      });

      if(json.error) {
        this.$store.dispatch("globalMessagePopup", json.error);
      } else {
        this.files.splice(index, 1);
      }
    },

    /**
     * Function to toggle signature list
     */
    selectSignature() {
      this.showSignatures = !this.showSignatures;
    },

    /**
     * Handler on checking/un-checking include signature checkbox
     */
    checkAndIncludeSignature() {
      this.setSignature(this.emailSignature);
    },

    /**
     * Function to set a signature
     */
    setSignature(signs, signatureListToggle = false) {
      this.emailSignature = signs;

      // Toggle signature list
      if(signatureListToggle) {
        this.showSignatures = !this.showSignatures;
      }

      // Add signature on mail body section
      if(this.showSignatureInsideMailBody) {
        this.addSignatureOnMailBody(signs);
      }
    },

    /**
     * Function to add signature on mail body
     */
    addSignatureOnMailBody(signature) {
      if(!this.includeSignature || 0 === signature.id) {
        tinyMCE.get('mailBody').dom.remove('signatureDiv');
      } else {
        let signatureHtml = `<div id="signatureDiv">${signature.signature}</div>`;
        tinyMCE.get('mailBody').dom.remove('signatureDiv');

        // Adding signature to mail body
        if(tinyMCE.get('mailBody').dom.get('startParagraphForward')) {
          let parents = tinyMCE.get('mailBody').dom.getParents('forwardMsgDottedLine');
          let currentNode;
          for( let i=0; i < parents.length; i++ ) {
            currentNode = parents[i];
            if( currentNode.nodeName == 'P' && currentNode.getAttribute( 'id' ) == 'forwardMsgDottedLine' ) {
              var doc = document.createRange().createContextualFragment(signatureHtml);
              currentNode.parentNode.insertBefore(doc, currentNode);
            }
          }
        } else {
          tinyMCE.get('mailBody').setContent(tinyMCE.get('mailBody').getContent() + signatureHtml);
        }
      }
      tinyMCE.get('mailBody').focus();
    },

    /**
     * Function to push contact to an array
     */
    pushToContact(event, contact) {
      event.stopPropagation();
      this.$refs.toInputTextBox.focus();
      this.selectedTo.push(contact);
      this.toTxtBoxVal = '';
      this.tofilteredContact= [];
    },

    /**
     * Function to add/remove contact from to contact list
     */
    toggleToContact(contact) {
      if(!this.searchOnContact(contact.id, this.selectedTo)) {
        this.selectedTo.push(contact);
      } else {

        // Deleting the contact.
        let selectedIndex = -1;
        this.selectedTo.find((toContact, index) => {
          if(toContact.id === contact.id) {
            selectedIndex = index;
            return true;
          }
        });

        if(selectedIndex > -1) {
          this.selectedTo.splice(selectedIndex, 1);
        }
      }
    },

    /**
     * Function to add/remove contact from cc contact list
     */
    toggleCcContact(contact) {
      if(!this.searchOnContact(contact.id, this.selectedCc)) {
        this.selectedCc.push(contact);
      } else {
        // Deleting the contact.
        let selectedIndex = -1;
        this.selectedCc.find((ccContact, index) => {
          if(ccContact.id === contact.id) {
            selectedIndex = index;
            return true;
          }
        });

        if(selectedIndex > -1) {
          this.selectedCc.splice(selectedIndex, 1);
        }
      }
    },

    /**
     * Function to add/remove contact from bcc contact list
     */
    toggleBccContact(contact) {
      if(!this.searchOnContact(contact.id, this.selectedBcc)) {
        this.selectedBcc.push(contact);
      } else {

        // Deleting the contact.
        let selectedIndex = -1;
        this.selectedBcc.find((bccContact, index) => {
          if(bccContact.id === contact.id) {
            selectedIndex = index;
            return true;
          }
        });

        if(selectedIndex > -1) {
          this.selectedBcc.splice(selectedIndex, 1);
        }
      }
    },

    /**
     * Removes a contact from to contact list
     */
    removeToContact(index) {
      this.selectedTo.splice(index, 1);
    },

    /**
     * Removes a contact from cc contact list
     */
    removeCcContact(index) {
      this.selectedCc.splice(index, 1);
    },

    /**
     * Removes a contact from bcc contact list
     */
    removeBccContact(index) {
      this.selectedBcc.splice(index, 1);
    },

    /**
     * Function to push a contact to cc contact list
     */
    pushCcContact(event, contact) {
      event.stopPropagation();
      this.$refs.ccInputTextBox.focus();
      this.selectedCc.push(contact);
      this.ccTxtBoxVal = '';
      this.ccfilteredContact = [];
    },

    /**
     * Function to push a contact to bcc contact list
     */
    pushBccContact(event, contact) {
      event.stopPropagation();
      this.$refs.bccInputTextBox.focus();
      this.selectedBcc.push(contact);
      this.bccTxtBoxVal = '';
      this.bccfilteredContact = [];
    },

    /**
     * Function to check mail contact
     */
    async checkMailContact(actionType) {
      this.emailSubject = this.emailSubject.trim();
      this.emailBody = this.emailBody.trim();
      if('send' === actionType) {
        // Checking the to contact list
        if (0 === this.selectedTo.length) {
          this.$store.dispatch("globalMessagePopup", "Please put at least one email address in the \"TO\" field.");
          return;
        }

        // Checking email subject
        if (!this.emailSubject.trim()) {
          this.$store.dispatch("globalMessagePopup", "Please specify a subject.");
          return;
        }

        // Checking email body
        if (!this.emailBody) {
          this.$store.dispatch("globalMessagePopup", "Please specify the mail content.");
          return;
        }

        // Checking for in-progress file
        let inProgressFile = this.files.find(file => {
          return (file.showUI && file.progress);
        });

        if(inProgressFile) {
          this.$store.dispatch("globalMessagePopup", "Some Files are on the process of uploading. Please wait till uploading finished.");
          return;
        }

      }

      // Constructing the to user ids
      let selectedToUserId = this.selectedTo.map(contact => {
          return contact.id;
      });

      // Constructing the cc user ids
      let selectedCcUserId = this.selectedCc.map(contact => {
        return contact.id;
      });

      // Constructing the bcc user ids
      let selectedBccUserId = this.selectedBcc.map(contact => {
        return contact.id;
      });

      // Constructing the attachments
      let attachments = [];
      this.files.forEach(file => {
        if(file.showUI) {
          attachments.push(file.fileId);
        }
      });

      // Appending the signature if the email is a direct draft or compose email
      let emailBody = this.emailBody;
      if((this.mailId === 0) && (this.emailSignature.id > 0) && (this.includeSignature)) {
        emailBody += `<div id="signatureDiv">${this.emailSignature.signature}</div>`;
      }

      this.emailFormData = new FormData();
      this.emailFormData.append('to', JSON.stringify(selectedToUserId));
      this.emailFormData.append('Cc', JSON.stringify(selectedCcUserId));
      this.emailFormData.append('Bcc', JSON.stringify(selectedBccUserId));
      this.emailFormData.append('subject', this.emailSubject);
      this.emailFormData.append('body', emailBody);
      this.emailFormData.append('attachments', JSON.stringify(attachments));
      this.emailFormData.append('actionType', actionType);
      this.emailFormData.append('mailActionType', this.mailActionType ? this.mailActionType : '');
      this.emailFormData.append('mailId', this.mailId ? this.mailId : 0);
      this.emailFormData.append('selectedSubscriberId', this.$store.getters.getSelectedProviderID);
      this.emailFormData.append('appUserId', this.selectedUserId);

      if(this.includeSignature) {
        this.emailFormData.append('signature', JSON.stringify(this.emailSignature));
      }

      if('send' === actionType) {
        this.setComposeEmailLoading(true);
        let checkMailContactRes = await this.$store.dispatch(
          "makeAuthRequestEmail",
          {
            url: "portalemail/checkMailContact",
            method: "POST",
            chat: true,
            data: this.emailFormData
          },
          {
            root: true
          }
        );
        this.setComposeEmailLoading(false);

        if (checkMailContactRes.error) {
          this.showMailContactConfirmBox = true;
          this.mailContactText = checkMailContactRes.error;
        } else {
          this.sendEmail();
        }
      } else {
        this.sendEmail();
      }
    },

    /**
     * Function to send an email
     */
    async sendEmail() {
      this.setComposeEmailLoading(true);
      let mailSendRes = await this.$store.dispatch(
        "makeAuthRequestEmail",
        {
          url: "portalemail/sendemail",
          method: "POST",
          chat: true,
          data: this.emailFormData
        },
        {
          root: true
        }
      );
      this.setComposeEmailLoading(false);

      if(mailSendRes.error) {
        this.$store.dispatch("globalMessagePopup", mailSendRes.error);
      } else {
        this.resetEmails({boxType: 'all', folderId: 0});
        this.setBoxCount({key: 'needLoad', value: true});
        if (!("previousRoute" in this) || this.previousRoute === "/") {
          this.$router.push("/daily");
        } else {
          if('edit' === this.mailActionType) {
            this.$router.push("/emails/draft");
          } else {
            this.$router.go(-1);
          }
        }
      }
    },

    /**
     * Function to go back to previous route
     */
    goBackToPrevRoute() {
      if (!("previousRoute" in this) || this.previousRoute === "/") {
        this.$router.push("/daily");
      } else {
        this.$router.go(-1);
      }
    },

    /**
     * Function to discard a draft
     */
    discardDraft() {
      this.goBackToPrevRoute();
    },

    searchOnContact(id, contactArray) {
      for (var i = 0; i < contactArray.length; i++) {
        if (contactArray[i].id === id) {
          return true;
        }
      }

      return false;
    },

    /**
     * To Text-box input change handler
     */
    toTextBoxInputChange(val) {
      if(val.trim() == '') {
          this.tofilteredContact = [];
          return;
      } else {
          this.tofilteredContact = this.getContactList.filter(el => {
              return el.name.toLowerCase().includes(val.toLowerCase()) && !(this.searchOnContact(el.id, this.selectedTo));
          });
      }
    },

    /**
     * CC Text-box input change handler
     */
    ccTextBoxInputChange(val) {
        if(val.trim() == '') {
            this.ccfilteredContact = [];
        } else {
            this.ccfilteredContact = this.getContactList.filter(el => {
                return el.name.toLowerCase().includes(val.toLowerCase()) && !(this.searchOnContact(el.id, this.selectedCc));
            });
        }
    },

    /**
     * BCC Textbox input change handler
     */
    bccTextBoxInputChange(val) {
        if(val.trim() == '') {
            this.bccfilteredContact = [];
        }

        this.bccfilteredContact = this.getContactList.filter(el => {
            return el.name.toLowerCase().includes(val.toLowerCase()) && !(this.searchOnContact(el.id, this.selectedBcc));
        });
    },

    /**
     * Function to pre-fill mail data on compose-email or reply/forward email
     */
    setEmailFields(mailDetails) {

      // Set Initial Email Details
      this.initialMailDetail = mailDetails;

      // Checking for email body
      if(mailDetails.message) {
        this.emailBody = mailDetails.message;
      }

      // Checking for email subject
      if(mailDetails.subject) {
        this.emailSubject = mailDetails.subject;
      }

      // Checking for to address array
      if(mailDetails.toArray && mailDetails.toArray.length > 0) {
        mailDetails.toArray.forEach(id => {
          let toUser = this.getContactList.find(el => {
            return el.id === id;
          });

          if(toUser) {
            this.selectedTo.push(toUser);
          }

        });
      }

      // Checking for CC address array
      if(mailDetails.ccArray && mailDetails.ccArray.length > 0) {
        this.showBcc = true;
        this.ccBccText = 'Cc';
        mailDetails.ccArray.forEach(id => {
          let ccUser = this.getContactList.find(el => {
            return el.id === id;
          });

          if(ccUser) {
            this.selectedCc.push(ccUser);
          }

        });
      }

      // Checking for to address array
      if(mailDetails.bccArray && mailDetails.bccArray.length > 0) {
        this.showBcc = true;
        this.ccBccText = 'Cc';
        mailDetails.bccArray.forEach(id => {
          let bccUser = this.getContactList.find(el => {
            return el.id === id;
          });

          if(bccUser) {
            this.selectedBcc.push(bccUser);
          }

        });
      }

      // The attachments is pushed in to files array
      if(mailDetails.attachments && (mailDetails.attachments.length > 0)) {
        mailDetails.attachments.forEach((attachment) => {

          this.files.push({
            progress: false,
            uploadPct: 100,
            uploadPercentage: {
              width: '100%'
            },
            showUI: true,
            fileId: attachment.id,
            fileDetail: {
              name: attachment.name
            },
            hideCloseIcon: attachment.hideCloseIcon
          });

        });
      }

      // Check email signature
      this.showSignatureInsideMailBody = true;

      // Saving the previous mailID and mail action type locally
      this.mailActionType = mailDetails.mailActionType;
      this.mailId = mailDetails.mailId;

      // Set email signature
      if(mailDetails.signature) {
        this.emailSignature = mailDetails.signature;
        this.includeSignature = true;
      }
    },

    /**
     * Handle click event on body
     */
    handleBodyClick() {
      // Hiding input box if the selected length is more then zero.
      if (this.selectedTo.length > 0) {
        this.toTxtBoxToggle = false;
      }
      if (this.selectedCc.length > 0) {
        this.ccTxtBoxToggle = false;
      }
      if (this.selectedBcc.length > 0) {
        this.bccTxtBoxToggle = false;
      }

      // Hiding the auto suggestion dropdown.
      if ((this.tofilteredContact.length > 0) || (this.toTxtBoxVal.trim() === '')) {
        this.tofilteredContact = [];
      }
      if ((this.ccfilteredContact.length > 0) || (this.ccTxtBoxVal.trim() === '')) {
        this.ccfilteredContact = [];
      }
      if (this.showBcc && ((this.bccfilteredContact.length > 0) || (this.bccTxtBoxVal.trim() === ''))) {
        this.bccfilteredContact = [];
      }

      // Hiding add icon.
      this.toAddIconToggle = false;
      this.ccAddIconToggle = false;
      this.bccAddIconToggle = false;
      this.toTxtBoxVal = '';
      this.ccTxtBoxVal = '';
      if (this.showBcc) {
        this.bccTxtBoxVal = '';
      }
    }
  },

  /**
   * The created hook, which will get called upon component created. Calling all the required API's here.
   */
  async created() {

    // Loading all the contact list
    this.setComposeEmailLoading(true);
    let contacts = await this.fetchAllContacts();
    if(contacts.error) {
      this.$store.dispatch("globalMessagePopup", contacts.error);
    }
    this.setComposeEmailLoading(false);

    // Setting default signature
    let defaultSignature = this.signatures.find((el) => {
      return (1 === el.is_default);
    });
    if(defaultSignature) {
      this.emailSignature = defaultSignature;
    }

    // Setting the contact id, if the user is sending mail from a contacts list
    if(this.getInitialMailDetails) {
      this.setEmailFields(this.getInitialMailDetails);
      this.setInitialMailDetails(null);
    }
  }
};
</script>

<style scoped>

::v-deep .lowerbody-section > .tox-tinymce {
  border: 0px solid #ccc !important;
  min-height:400px;
}

/* Chanaging the dropdown color on hover */
.email-autosuggestions li:hover {
    background-color: #ddd;
    cursor: pointer;
}

/* The email signature list hover effect */
.indv-signature :hover {
  cursor: pointer;
}

.compose-email-container{
  margin-top: 122px;
}
.subject-section input{
  width: calc(100% - 90px)!important;
    position: absolute;
    font-size: 16px;
    top:13px;
    padding: 0;
vertical-align: top;
margin: 0;
line-height: 20px;
}
section {
  margin-top: 126px;
}

.add-new-icon {
  width: 35px;
  height: 35px;
}

.heading-end {
  cursor: pointer;
}

span.fill {
  flex-grow: 1;
}

.heading .heading-end {
  position: fixed;
  top: 54px;
  right: 14px;
  z-index: 9999;
}

.swipe-enter-active {
  animation: swipeIn 0.2s ease-in-out;
}

.swipe-leave-active {
  animation: swipeOut 0.2s ease-in-out;
}

.swipe-move {
  transition: all 0.2s ease-in-out;
}
.to-section, .cc-section, .bcc-section, .lowerbody-section{
  border-bottom:1px solid #ddd;
  padding:7px 10px;
  display:flex;
  justify-content: flex-start;
  align-items: flex-start;
  position:relative;
}
.to-section ul, .cc-section ul, .bcc-section ul{
  }
   .upperbody-section{
    display:block;
    padding:12px 10px 7px;
    border-bottom: 1px solid #ddd;
  }
  .compose-label{
    display:inline-block;
    padding-top:6px;
  }
  .subject-section .compose-label{
    padding-right:8px;
    padding-top:0;
  }
  .selected-to-email, .selected-cc-email, .selected-bcc-email{
    width:auto;
    display:inline-block;
    position:relative;
    top:5px;
    flex:2;
  }
  .selected-to-email li, .selected-cc-email li, .selected-bcc-email li{
    float: left;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius:3px;
    font-size: 13px;
    margin:0 5px 5px 5px;
    padding-right: 10px;
    line-height: 18px;
    position:relative;
  }
  .selected-to-email li:last-child, .selected-cc-email li:last-child, .selected-bcc-email li:last-child{
    border:none;
    padding-top:0;
  }
  .selected-to-email span, .selected-cc-email span, .selected-bcc-email span{
    padding-right: 5px;
  }
  .selected-to-email span.icon-close, .selected-cc-email span.icon-close, .selected-bcc-email span.icon-close{
    padding-right: 5px;
    position: relative;
    top:2px;
  }
  /*----Contacts Lis----*/
  .to-section{
    position:relative;
  }
  .contacts-container{
    width:98%;
    background:#fff;
    left:10px;
    top:45px;
    position:absolute;
    z-index:9;
    border-radius:5px;
    border:1px solid #ddd;
  }
  .contacts-container.collapsed{
    position:fixed;
    bottom:0!important;
    max-height:94px;
    top:unset;

  }
  .contacts-header{
    position:relative;
    background:#f6f6f6;
    padding:10px;
    text-align: center;

  }
  .contacts-header h2{
    font-size:18px;
    font-weight: bold;
    margin:0 0 15px;
    position: relative;
  }
  .contacts-header h5{
    font-size:14px;
    margin:10px 0 15px;
  }
  .contacts-header a{
    font-weight: bold;
    font-size:14px;
    position:absolute;
    right: 10px;
    top:10px;
  }
  .all-contacts-list{
    padding:10px;
  }
  .all-contacts-list li{
    padding:10px 0;
    margin:10px 0;
    border-bottom:1px solid #ddd;
    position:relative;
  }
  .all-contacts-list li:last-child{
    border-bottom:none;
  }

  .contact-selected, .deselect-contact, .close-contacts-list, .expand-contacts-list{
  width:24px;
  height: 24px;
  background:url('../../../assets/img/icon-selected.png');
  position:absolute;
  top:2px;
  right:10px;
  display:block;
}
.contact-selected.active{
  right:0px;
}
.close-contacts-list{
     background:url('../../../assets/img/icon-collapse-v1.png');
  position:absolute;
  top:2px;
  right:10px;
}
.expand-contacts-list{
     background:url('../../../assets/img/icon-expand-v1.png');
  position:absolute;
  top:2px;
  right:10px;
}
  .email-autosuggestions{
    padding:0;
    position: absolute;
    left:0;
    top:32px;
     border: 1px solid #ccc;
     width:100%;
     background:#fff;
     z-index:999;

  }
  .email-autosuggestions li{
    padding:10px!important;
    display:block;
    width:calc(100% - 20px);
    float:none;
    border:none;
    border-bottom:1px solid #ccc;
    margin:0;
    border-radius:0!important;
  }
   .icon-close::before, .icon-close::after {
    content: "";
    width: 3px;
    height: 100%;
    background-color: #000;
    border-radius: 4px;
    position: absolute;
    right: 4px;
    -webkit-transform: rotate(
45deg
);
    transform: rotate(
45deg
);
}
.icon-close::after {
    -webkit-transform: rotate(
-45deg
);
    transform: rotate(
-45deg
);
}
.cc-section input, .bcc-section input, .subject-section input{
  flex:2;
}
  input{
    outline:none;
    border:none;
  }
  .add-more{
    width:24px;
    height: 24px;
   text-align: center;
    display: inline-block;
    float: right;
    cursor: pointer;
      background:url('../../../assets/img/icon-add.png')!important;
        position:absolute;
      top:50%;
      margin-top:-12px;
      right:15px;

  }
.buttonstyle{
  float:none;
  border:none!important;
  border-radius: 2px;
  outline:none;
}
.select-sig{
  color:#d26d13;
  font-size: 14px;
  cursor: pointer;
}
.icon-attachment{
  max-width: 24px;
  float:right;
  cursor: pointer;
}
 .lowerbody-section, .subject-section{
    display:block;
    padding:15px 10px;
  }
  .subject-section{
  border-bottom:1px solid #ddd;
  position:relative;
}
.lowerbody-section textarea{
     width: 100%;
    min-height: 100px;
    border:none;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    outline: none;
    line-height:22px;
}
.lowerbody-section{
  padding:0!important;
}
.lowerbody-section .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before{
  color:000!important;
  font-size:14px!important;
}

.all-signatures{
  margin:10px 0 10px 5px;
  padding:10px;
  max-width:280px;
  width:100%;
  border:1px solid #ccc;
}
.all-signatures li{
  margin:10px 0;
  padding-bottom:10px;
  border-bottom:1px solid #ddd;
  font-size:14px;
}
.all-signatures li label div{
  position:relative;
  top:-18px;
  left:25px;
  width:calc(100% - 25px);
  line-height: 18px;
}
.all-signatures li label div h2{
  font-size:16px;
  font-weight: bold;
}
.all-signatures li:last-child{
  border-bottom:none;
}
/*---checkbox--*/
.form-check-input{
  width:16px;
  height:16px;
}
.form-check-input:checked {
    background-color:#5888c5!important;
    border-color:#5888c5!important;
}
.include-signature{
  font-size:14px;
}
/*---Checkbox--*/
.include-signature label.container-checkbox {
  padding-left:25px;
  position:relative;
  top:0;
}
.include-signature label.container-checkbox{
  padding-left:25px;
  position: relative;
  top:0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.include-signature label.container-checkbox .checkmark {
    height: 18px;
    width: 18px;
    border-radius:3px;
    position: absolute;
    left:0;
    top:0;
    border:1px solid #5888c5!important;
  }

 .include-signature label.container-checkbox .checked::after {
  content: "";
  background:#5888c5 url('../../../assets/img/icon-checked.png')!important;
  width: 18px;
  height: 19px;
    position: absolute;
    left:0;
    top:0;
 }

.include-signature label.container-checkbox input {
    left:-3px;
    top:-2px;
      position: absolute;
      width:18px;
      height:18px;
      border:none!important;
      opacity:0;
}

.signature-preview{
  font-style: italic;
  font-weight: bold;
  color: #5888c5;
  margin:0 20px;
}
.signature-files{
  margin:10px;
}
.signature-file-con{
  margin:10px 0 15px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom:10px;
  border-bottom:1px solid #f6f6f6;
}
.signature-file-con:last-child{
  border-bottom:none;
}
.file-close{
  width:24px;
  height: 24px;
  background:url('../../../assets/img/icon-close-medium.png');
  display:inline-block;
  margin-left:10px;
  position: relative;
  top:-1px;
  cursor: pointer;
}
.icon-close::before, .icon-close::after{
  width:2px;
}
/*--Progress Bar--*/
.progress-bar-container{
  position: relative;
  width:100%;
  padding:10px 0;
}
.progress-bar-area{
  width:calc(100% - 30px);
  float:left;
}
.progress {
    display: flex;
    height: 24px;
    overflow: hidden;
    font-size: .75rem;
    background-color: #e9ecef;
    border-radius: .25rem;
}
.progress-bar {
    display: flex;
     flex-direction: column;
    justify-content: center;
    color: #fff;
    text-align: center;
    background-color: #008bc5;
    transition: width .6s ease;
}
.cancel-upload{
  float:right;
  width:24px;
  height: 24px;
  display:block;
  background:url('../../../assets/img/icon-close-medium.png');
  margin-top:0px;
  cursor: pointer;
}

@keyframes swipeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@media screen and (max-width:768px){
  .contacts-container{
    width:calc(100% - 20px);
  }


}

/* This animation is for contact list */
.pop-up-enter-active {
  animation: fade-in-up 0.2s ease-in-out forwards;
}

.pop-up-leave-active {
  animation: fade-in-down 0.2s ease-in-out forwards;
}
@keyframes fade-in-up {
  from {
    transform: translate3d(0,40px,0);
    opacity: 0;
  }

  to {
    transform: translate3d(0,0,0);
    opacity: 1;
  }
}

@keyframes fade-in-down {
  from {
    transform: translate3d(0,0,0);
    opacity: 1;
  }

  to {
    transform: translate3d(0,40px,0);
    opacity: 0;
  }
}

/* Zoom in/out animation */
div >>> .zoom-enter-active {
  animation: zoomIn 0.2s ease-in-out forwards;
}

div >>> .zoom-leave-active {
  animation: zoomOut 0.2s ease-in-out forwards;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}

</style>
